import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { createSchool } from "../../../services/operations/schoolAPI";

const AddSchoolPage = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    address: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.email) {
      toast.error("Please fill all required fields");
      return;
    }

    setLoading(true);

    const success = await createSchool(form, navigate);

    setLoading(false);

    if (success) {
      setForm({ name: "", email: "", address: "" });
    }
  };

  return (
    <div className="min-h-screen bg-white px-6 pt-4 pb-6 flex flex-col gap-6">
      {/* HEADER */}
      <div>
        <h2 className="text-xl font-semibold text-blue-900">Add New School</h2>
        <p className="text-gray-500 text-md font-semibold mt-1">
          Create and register a new school in the platform
        </p>
        <div className="h-[2px] w-full bg-blue-500 mt-2" />
      </div>

      {/* FORM SECTION */}
      <div className="flex flex-col md:flex-row gap-10 justify-center items-center">
        <div className="bg-gray-100 rounded-xl shadow-md p-8 w-full max-w-md">
          <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
            
            {/* SCHOOL NAME */}
            <div>
              <label className="text-sm font-semibold text-gray-700">
                School Name
              </label>
              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md 
                focus:outline-none focus:ring focus:ring-blue-300"
                type="text"
                placeholder="Enter school name"
              />
            </div>

            {/* SCHOOL EMAIL */}
            <div>
              <label className="text-sm font-semibold text-gray-700">
                School Email
              </label>
              <input
                name="email"
                value={form.email}
                onChange={handleChange}
                className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md 
                focus:outline-none focus:ring focus:ring-blue-300"
                type="email"
                placeholder="Enter school email"
              />
            </div>

            {/* SCHOOL ADDRESS */}
            <div>
              <label className="text-sm font-semibold text-gray-700">
                Address
              </label>
              <textarea
                name="address"
                value={form.address}
                onChange={handleChange}
                className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md 
                focus:outline-none focus:ring focus:ring-blue-300"
                rows={3}
                placeholder="Enter full school address"
              />
            </div>

            {/* BUTTONS */}
            <div className="flex justify-end gap-4 pt-2">
              <button
                type="button"
                onClick={() => navigate("/dashboard/super-admin/schools")}
                className="border border-blue-900 text-blue-900 px-5 py-2 rounded-full 
                text-sm font-medium hover:bg-blue-50"
              >
                Cancel
              </button>

              <button
                type="submit"
                disabled={loading}
                className="bg-blue-900 text-white px-6 py-2 rounded-full text-sm 
                font-medium hover:bg-blue-800 disabled:opacity-60"
              >
                {loading ? "Adding..." : "Add School"}
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default AddSchoolPage;
